import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  //   isHumanNameStateChanged: false,
  //   isAddressStateChanged: false,
  //   isTelecomStateChanged: false,
  //   isBasePatientStateChanged: false,
  isPatientStateChanged: false,
  arePermissionsChanged: false,
};

const payloadValues = {};

const stateDetectorSlice = createSlice({
  name: 'stateDetectorSlice',
  initialState,
  reducers: {
    setStateDetectorState: (state, action) => {
      Object.assign(payloadValues, action?.payload);
      const auxState = { ...state, ...payloadValues };
      const isPatientStateChanged =
        Boolean(auxState?.isHumanNameStateChanged) ||
        Boolean(auxState?.isAddressStateChanged) ||
        Boolean(auxState?.isTelecomStateChanged) ||
        Boolean(auxState?.isBasePatientStateChanged) ||
        Boolean(auxState?.isLocationStateChanged) ||
        Boolean(auxState?.isHealthScoreFormChanged) ||
        Boolean(auxState?.isPatientFormChanged) ||
        Boolean(auxState?.isFamilyMemberHistoryChanged) ||
        Boolean(auxState?.isPastMedicalHistoryStateChanged) ||
        Boolean(auxState?.isSocialHistoryStateChanged) ||
        Boolean(auxState?.coverage0Changed) ||
        Boolean(auxState?.coverage1Changed) ||
        Boolean(auxState?.coverage2Changed) ||
        Boolean(auxState?.coverage3Changed) ||
        Boolean(auxState?.coverage4Changed) ||
        Boolean(auxState?.isHealthScoreFormChanged) ||
        Boolean(auxState?.isPatientFormChanged) ||
        Boolean(auxState?.isFamilyMemberHistoryChanged) ||
        Boolean(auxState?.isEncounterChanged) ||
        Boolean(auxState?.isVitalsChanged) ||
        Boolean(auxState?.isPractitionerChanged);

      state.isPatientStateChanged = Boolean(isPatientStateChanged);
    },

    resetStateDetectorState: () => {
      for (var prop in payloadValues) {
        delete payloadValues[prop];
      }
      return initialState;
    },
    setPermissionsChanged: (state, action) => {
      state.arePermissionsChanged = action?.payload;
    },
  },
});

export const {
  setStateDetectorState,
  resetStateDetectorState,
  setPermissionsChanged,
} = stateDetectorSlice.actions;
export default stateDetectorSlice.reducer;
